/* eslint-disable */
export const stringToSlug = (str) => {
  str = str.trim().toLowerCase().replace(/[^a-zA-Z0-9-]/g, '-');
  str = str.replace(/\s+/g, '-');
  str = str.replace(/-+/g, '-');
  str = str.replace(/^-+|-+$/g, '');
  return str;
};
